module.exports = __webpack_public_path__ + "static/media/bg_12.fea1a715.png";